module.exports = __webpack_public_path__ + "img/CBD-gelcaps-50mg.8d3f4be2.jpg";